import axios from '../../axios.js'

// eslint-disable-next-line no-unused-vars
function parsePayload(payload, type, status) {
  if (payload['s']) {
    payload['s']['$and'] = payload['s']['$and'] ? payload['s']['$and'] : {}
  } else if (payload['join']) {
    payload['join'] = payload['join']
  } else {
    payload['s'] = {}
  }
  return payload
}
export default {
  fetchCollectionDashboardData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/billing-docs/invoiced-collection', {
          params: payload,
        })
        .then((response) => {
          commit('SET_COLLECTION_DASHBOARD', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  fetchPreEinvoiceCreationCount({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/billing-docs/pre-einvoice-creation-count', {
          params: payload,
        })
        .then((response) => {
          commit('SET_PRE_EINVOICE_CREATION_COUNT', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  fetchBillingDocCount({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/billing-docs/count', {
          params: payload,
        })
        .then((response) => {
          commit('SET_DASHBOARD_BILLINGDOCS_COUNT', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  fetchDashboardSummaryData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/billing-docs/summary', {
          params: payload,
        })
        .then((response) => {
          commit('SET_DASHBOARD_SUMMARY', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchPrintRecords(context, payload) {
    // load invoices
    return new Promise((resolve, reject) => {
      axios
        .get('/billing-docs', {
          params: parsePayload(payload),
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchRecords({ commit }, payload) {
    // load invoices
    return new Promise((resolve, reject) => {
      axios
        .get('/billing-docs', {
          params: parsePayload(payload),
        })
        .then((response) => {
          commit('SET_INVOICES', response.data)
          commit('SET_PAGINATION', {
            currentPage: response.headers['x-pagination-page'],
            totalPage: response.headers['x-pagination-page-count'],
            pageTotal: response.headers['x-pagination-count'],
            totalItem: response.headers['x-pagination-total'],
          })
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchRecord(context, docNo) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/billing-docs/${encodeURIComponent(docNo)}?join=attachments`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addRecords(context, items) {
    return new Promise((resolve, reject) => {
      axios
        .post('/billing-docs/bulk', { bulk: items })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addRecord(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('/billing-docs', payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeInvoice({ commit }, docNo) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/billing-docs/${encodeURIComponent(docNo)}`)
        .then((response) => {
          commit('DELETE_INVOICE', docNo)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeProFormaInvoice({ commit }, docNo) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/billing-docs/${encodeURIComponent(docNo)}`)
        .then((response) => {
          commit('DELETE_PRO_FORMA_INVOICE', docNo)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  cancelConsolidatedInvoice(context, docNo) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/billing-docs/${encodeURIComponent(docNo)}/cancelConsolidated`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeCndn({ commit }, docNo) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/billing-docs/${encodeURIComponent(docNo)}`)
        .then((response) => {
          commit('DELETE_CN_DN', docNo)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeRn({ commit }, docNo) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/billing-docs/${encodeURIComponent(docNo)}`)
        .then((response) => {
          commit('DELETE_RN', docNo)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeRecords({ commit }, items) {
    return new Promise((resolve, reject) => {
      items.forEach(function (item) {
        axios
          .delete(`/billing-docs/${encodeURIComponent(item.docNo)}`)
          .then((response) => {
            commit('DELETE_PF', item.docNo)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    })
  },
  getEmailText(context, item) {
    return new Promise((resolve, reject) => {
      var emailType = 'invoice-created-email'
      if (
        item.eInvoice &&
        item.eInvoice.status == 'valid' &&
        item.eInvoice.generatedFileUrl
      )
        emailType = 'invoice-validated-email'

      axios
        .get(
          `billing-docs/${encodeURIComponent(item.docNo)}/${
            item.type
          }/${emailType}/email-payload`
        )
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  generateInvoicePdf(context, doc) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `/billing-docs/${encodeURIComponent(doc.docNo)}/${doc.type}/generate`
        )
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  sendReminder(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/email/devReminder', {
          params: payload,
        })
        .then((response) => {
          //commit("SET_DASHBOARD_SUMMARY", response.data);
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  async invoiceListingMail(contxt, payload) {
    try {
      const response = await axios.post(
        '/billing-docs/invoice-listing-email',
        payload
      )
      if (response.status !== 200) return response
      else return response
    } catch (err) {
      return err
    }
  },
  /**
   * Submit documents to IRSP (Singapore Peppol / InvoiceNow)
   * 
   * @param {Object} context - Vuex context
   * @param {Object} payload - Submission payload
   * @param {Array<{docNo: string, type: string}>} payload.billingDocs - Array of billing docs with docNo and type
   * @param {string} [payload.destination] - Optional: 'C3C5' (Peppol+IRAS) or 'C5' (IRAS only)
   * @returns {Promise} Response with submission details
   * 
   * API: POST /irsp-submissions
   */
  async sendIrspData(context, payload) {
    try {
      const requestBody = {
        billingDocs: payload.billingDocs || [],
      }
      
      // Only include destination if explicitly provided
      if (payload.destination) {
        requestBody.destination = payload.destination
      }
      
      const response = await axios.post('/irsp-submissions', requestBody)
      return response
    } catch (err) {
      console.error('[IRSP] Failed to create submission:', err)
      throw err
    }
  },
  fetchOrders({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/billing-docs', {
          params: parsePayload(payload),
        })
        .then((response) => {
          commit('SET_ORDERS', response.data)
          commit('SET_PAGINATION', {
            currentPage: response.headers['x-pagination-page'],
            totalPage: response.headers['x-pagination-page-count'],
            pageTotal: response.headers['x-pagination-count'],
            totalItem: response.headers['x-pagination-total'],
          })
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchOrderSummary({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get('/billing-docs/order-summary')
        .then((response) => {
          commit('SET_ORDER_SUMMARY', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchOrderIrspStatus(context, docNo) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/billing-docs/${encodeURIComponent(docNo)}/order/irsp-status`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  convertOrderToInvoice(context, { docNo, invoiceDocNo }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/v2/billing-docs/${encodeURIComponent(docNo)}/convert-to-invoice`, {
          invoiceDocNo,
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeOrder({ commit }, docNo) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/billing-docs/${encodeURIComponent(docNo)}`)
        .then((response) => {
          commit('DELETE_ORDER', docNo)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  refreshIrspSubmission(context, uuid) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/irsp-submissions/${encodeURIComponent(uuid)}/refresh`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  async addEInvoiceRecord(context, payload) {
    try {
      const response = await axios.post('/e-invoices/bulk', {
        bulk: payload,
      })
      if (response.status !== 200) return response
      else return true
    } catch (err) {
      return err
    }
  },
  async consolidateInvoices(context, payload) {
    try {
      const response = await axios.post(
        '/billing-docs/generate-consolidated-invoices',
        payload
      )
      if (response.status !== 200) return response
      else return true
    } catch (err) {
      return err
    }
  },
}
